import MetricBase from "models/metrics/MetricBase";
import ConversionGroup from "models/groups/ConversionGroup";
import EmptyUnit from "models/metrics/unit/EmptyUnit";
import i18n from "i18next";

class MetricBookingCountGhaPPA extends MetricBase {
    constructor() {
        super({
            field: "metric_bookingcount",
            defaultVisibility: true,
            unit: new EmptyUnit(),
            chartName: i18n.t("metrics.google_hotel_ads_ppa.bookingcount.chartName"),
            serieLabel: i18n.t("metrics.google_hotel_ads_ppa.bookingcount.serieLabel"),
            tooltip: i18n.t("metrics.google_hotel_ads_ppa.bookingcount.tooltip"),
            group: new ConversionGroup(),
        });
    }
}

export default MetricBookingCountGhaPPA;
